export class Additional_field {
	name: string;
	label: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}

export class Additional_field_response {
	name: string;
	value: any;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	
}